import Backbone from 'backbone';
import { reflow } from './util';
import { getFocusables, onTabKeyDownCallback } from '../utils/header-focusable';

const MembershipNav = Backbone.View.extend({
  events: {
    "click [data-membership-menu-trigger]": "onClickTrigger",
  },
  initialize() {
    this.zIndex          = getComputedStyle(this.el).zIndex;
    this.menuTrigger     = this.$('[data-membership-menu-trigger]')[0];
    this.menuTriggerIcon = this.$('[data-membership-menu-trigger] [data-membership-menu-trigger-label]')[0];
    this.menuTriggerIconSvg = this.$('[data-membership-menu-trigger] [data-membership-menu-trigger-label] svg')[0];
    this.menu            = this.$('[data-membership-menu]')[0];
    this.shouldRotateIcon = this.menuTriggerIcon.hasAttribute('data-membership-menu-trigger-rotate');
    this.initListeners();
  },
  initListeners() {
    this.boundOnKeyDown = this.onKeyDown.bind(this);
    this.boundOnFadeInTransitionEnd = this.onFadeInTransitionEnd.bind(this);
    this.boundOnFadeOutTransitionEnd = this.onFadeOutTransitionEnd.bind(this);
    this.listenTo(Backbone, {
      'overlay:click':  this.closeMenu,
      'overlay:cancel': this.closeMenu
    });
  },
  isMenuOpen() {
    return this.menuTrigger.getAttribute('aria-expanded') === 'true';
  },
  onClickTrigger() {
    if (this.isMenuOpen()) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  },
  openMenu() {
    if (this.menu && this.menuTrigger) {
      this.clearTransitionEndListeners();

      this.menu.style.display = 'block';
      reflow(this.menu);
      this.menuTrigger.setAttribute('aria-expanded', true);

      if (this.shouldRotateIcon) {
        this.menuTriggerIconSvg.classList.remove('typography/icon:after:90deg');
        this.menuTriggerIconSvg.classList.add('typography/icon:after:270deg');
      }

      this.menu.addEventListener('transitionend', this.boundOnFadeInTransitionEnd);
      document.addEventListener('keydown', this.boundOnKeyDown);
      Backbone.trigger('membership-nav:menu:open', { zIndex: this.zIndex });
    }
  },
  closeMenu() {
    if (this.menu && this.menuTrigger) {
      this.clearTransitionEndListeners();

      this.menuTrigger.removeAttribute('aria-expanded');

      if (this.shouldRotateIcon) {
        this.menuTriggerIconSvg.classList.remove('typography/icon:after:270deg');
        this.menuTriggerIconSvg.classList.add('typography/icon:after:90deg');
      }

      this.focusables = [];

      this.menu.addEventListener('transitionend', this.boundOnFadeOutTransitionEnd);
      document.removeEventListener('keydown', this.boundOnKeyDown);
      Backbone.trigger('membership-nav:menu:close');
    }
  },
  clearTransitionEndListeners() {
    if (this.menu) {
      this.menu.removeEventListener('transitionend', this.boundOnFadeInTransitionEnd);
      this.menu.removeEventListener('transitionend', this.boundOnFadeOutTransitionEnd);
    }
  },
  onFadeInTransitionEnd(e) {
    if (e.propertyName === 'opacity') this.focusables = getFocusables(this.menu);
    if (this.menu) this.menu.removeEventListener('transitionend', this.boundOnFadeInTransitionEnd);
  },
  onFadeOutTransitionEnd() {
    if (this.menu) {
      this.menu.removeEventListener('transitionend', this.boundOnFadeOutTransitionEnd);
      this.menu.style.display = 'none';
    }
  },
  onKeyDown(e) {
    if (this.isMenuOpen() && this.focusables) onTabKeyDownCallback(e, this.focusables, this.closeMenu.bind(this));
  },
  dispose() {
    this.closeMenu();
    this.clearTransitionEndListeners();
    this.undelegateEvents();
    this.stopListening();
  },
});

export default MembershipNav;
